import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";

function CustomModal({ isModal, handleModal, size, children, index, titleId = "modal-title" }) {
  const sizeClasses = {
    sm: "sm:max-w-sm",
    md: "sm:max-w-md",
    lg: "sm:max-w-lg",
    xl: "sm:max-w-xl",
    "2xl": "sm:max-w-2xl",
    "3xl": "sm:max-w-3xl",
    "4xl": "sm:max-w-4xl",
    "5xl": "sm:max-w-5xl",
    "6xl": "sm:max-w-6xl",
  };

  useEffect(() => {
    if (!isModal) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape") handleModal();
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [isModal, handleModal]);

  return (
    <div
      className={`fixed inset-0 ${index ? index : "z-overlay"} w-screen overflow-y-auto ${
        isModal ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"
      }`}
      aria-labelledby={titleId}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="fixed inset-0 bg-gx-navy/50 transition-opacity"
        aria-hidden="true"
        onClick={handleModal}
      />
      <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <div
          className={`relative transform overflow-y-auto max-h-[90vh] rounded-gx bg-gx-surface text-left shadow-gx sm:my-8 sm:w-full transition-all duration-200 ${
            sizeClasses[size] || "sm:max-w-md"
          } ${isModal ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}
        >
          <button
            type="button"
            aria-label="Close dialog"
            className="absolute top-3 right-3 z-10 h-11 w-11 inline-flex items-center justify-center rounded-gx-control text-gx-ink-soft hover:text-gx-red hover:bg-gx-canvas transition-colors"
            onClick={handleModal}
          >
            <FontAwesomeIcon icon={faXmark} size="lg" />
          </button>
          <div className="bg-gx-surface">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default CustomModal;
